<template>
    <el-dialog @opened="cshData" :visible.sync="mylCz.mylOpenShow" :show-close="false" :close-on-click-modal="false">
        <div style="box-sizing: border-box;padding: 20px;height: 100%;">
            <div style="background-color: #f7f7f7;height: 100%;">
                <div style="display: flex;align-items: center;">
                    <div style="color: #323232;font-size: 18px;font-weight: 700;margin-left: 30px;">
                        面雨量
                    </div>
                    <tab-switch :buttonNamesArr="buttonNamesArr" :delImg="mylCz.mylOpenShow" @delImgDeal="delImgDeal" @curTabButtonClickDeal="curTabButtonClickDeal" style="background-color: #f7f7f7;">
                    </tab-switch>
                </div>
                <div style="margin: 10px 0;width: 100%;">
                    <span style="font-size: 14px;margin-right: 10px;margin-left: 30px;">时段</span>
                    <el-select v-model="orForm.hour" placeholder="请选择" size="small" style="width: 120px;" @change="sjdChange">
                        <el-option
                            v-for="item in sjdOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                    <span style="font-size: 14px;margin-right: 10px;margin-left: 30px">时间</span>
                    <span v-if="orForm.hour == 0">
                        <el-date-picker
                            v-model="mylCz.sjfw"
                            :clearable=false
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            popper-class='myDatePicker'
                            type="datetimerange"
                            range-separator="到"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            @change="sjChange"
                        >
                        </el-date-picker>
                    </span>
                    <span v-else>
                        <el-date-picker
                            v-model="mylCz.sjfw"
                            :clearable=false
                            value-format="yyyy-MM-dd HH:mm"
                            format="yyyy-MM-dd HH:mm"
                            popper-class='myDatePicker'
                            type="datetimerange"
                            range-separator="到"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            @change="sjChange"
                        >
                        </el-date-picker>
                    </span>
                    <el-button type="primary" size="small" class="czBut queryButton" @click="oreset">重置</el-button>
                    <el-button type="primary" icon="el-icon-search" size="small" class="queryButton queryButtonPadding" @click="jygcData">搜索</el-button>
                    <el-button type="primary" size="small" class="queryButton queryButtonPadding qDcBtn" @click="exportJygc">
                        <el-image class="qDcImg" :src="require('@/assets/buttonGathers/query-dc.png')"></el-image>
                        &nbsp;导出
                    </el-button>
                </div>
                <el-row :gutter="20" style="padding: 0 20px;" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
                    <el-col :span="12">
                        <div style="height:calc(100vh - 280px);width: 100%;background-color: #fff;padding-top: 20px;box-sizing: border-box;">
                            <div id="chartZxt" class="zxtys"></div>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div style="height:calc(100vh - 280px);width: 100%;background-color: #fff;position: relative;">
                            <div style="width:100%;height:100%">
                                <el-table height="calc(100% - 60px)" :data="otableData" border :header-cell-style="{background:'#f9f9ff',color:'#323232','text-align':'center'}" >
                                    <el-table-column v-if="orForm.hour == 0" prop="tm" label="时间" align="center"/>
                                    <el-table-column v-else prop="ht" label="时间" align="center"/>
                                    <el-table-column prop="rainValue" label="雨量（mm）" align="right">
                                        <template slot-scope="scope">
                                                <span>
                                                    {{ scope.row.rainValue ? scope.row.rainValue : '-' }}
                                                </span>
                                            </template>
                                    </el-table-column>
                                    <el-table-column prop="dhpSum" label="累计雨量（mm）" align="right">
                                        <template slot-scope="scope">
                                            <span>
                                                {{ scope.row.dhpSum ? scope.row.dhpSum : '-' }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <page-footer
                                :rForm="orForm"
                                @size-change="osizeChange"
                                @current-change="ocurrentChange"
                                style="position: absolute;bottom: 10px;right: 20px;"
                            >
                            </page-footer>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import pageFooter from "@/components/pageFooter";
import tabSwitch from "@/components/buttonGather/tabSwitch";
import { fileHost } from "@/utils/config";
export default {
    name: "rainOpen",
    components: {
        pageFooter,
        tabSwitch
    },
    props:{
        mylCz:{
            type:Object
        },
    },
    data() {
        return {
            fileHost:fileHost,
            loading:false,
            csTime:[],
            buttonNamesArr:[],
            czOptions:[],
            delImg: false,
            activeName: 1,
            sstj:{
                sjd:'监测',
            },
            // 查询表单
            orForm: {
                size: 20,
                current: 1,
                total: 0,
                czOrbh:"",
                hour:1,
            },
            sjdOptions: [
                {
                    value: 1,
                    label: '一小时'
                }, {
                    value: 3,
                    label: '三小时'
                }, {
                    value: 6,
                    label: '六小时'
                }, {
                    value: 12,
                    label: '十二小时'
                }, {
                    value: 24,
                    label: '二十四小时'
                }
            ],
            jcTime:[],
            otableData:[],
            ozxtData:[],
            ozxtDataX:[],
            ozxtDataY1:[],
            ozxtDataY2:[],
            jbxx:{},
        };
    },
    methods:{
        xgDate(dateStr){
            dateStr = dateStr.substring(0,19);
            dateStr = dateStr.replace(/-/g,'/');
            var timeTamp = new Date(dateStr).getTime();
            return timeTamp;
        },
        delImgDeal(){
            this.mylCz.mylOpenShow = false;
            this.orForm.hour = 1;
            this.activeName = 1;
        },
        curTabButtonClickDeal(val){
            this.activeName = val;
            this.czqh();
        },
        czqh(){
            if (this.activeName == 1) {
                this.jbxxData();
            } else {
                this.jygcData();
            }
        },
        cshData(){
            this.csTime = this.mylCz.sjfw;
            this.jcTime = this.mylCz.sjfw;
            this.sjdChange(this.orForm.hour);
        },
        jygcData(){
            let qwer1 = this.xgDate(this.mylCz.sjfw[0].substr(0,13) + ':00:00');
            let qwer2 = this.xgDate(this.mylCz.sjfw[1].substr(0,13) + ':00:00');
            qwer1 = qwer1/(60*60*1000);
            qwer2 = qwer2/(60*60*1000);
            let qwer = qwer2 - qwer1;
            if (qwer > 8784) {
                this.$message.warning('查询时间不允许超过一年！');
                return;
            }


            if (this.jcTime.length < 1 || this.orForm.hour == 0) {
                this.jcTime = this.mylCz.sjfw;
            }
            this.delImg = this.mylCz.mylOpenShow;
            this.zxtData();
            this.bgData();
        },
        sjChange(){
            this.jcTime = this.mylCz.sjfw;
        },
        sjdChange(val){
            if (val == 1) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime = this.xgDate(this.jcTime[1] + ':00');
                if (hqTime%(60*60*1000) == 0) {
                    hqTime = new Date(hqTime);
                } else {
                    hqTime = new Date(hqTime + 1 * 60 * 60 * 1000);
                }
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh:mm',hqTime).substr(0,13) + ':00';
                this.mylCz.sjfw = aaTime;
            } else if (val == 3) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (((hqTime1 - hqTime0)/(60*60*1000))%3 == 0) {
                    var hqTime3 = 0;
                } else {
                    var hqTime3 = 3 - ((hqTime1 - hqTime0)/(60*60*1000))%3;
                }
                var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh:mm',hqTime).substr(0,13) + ':00';
                this.mylCz.sjfw = aaTime;
            } else if (val == 6) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (((hqTime1 - hqTime0)/(60*60*1000))%6 == 0) {
                    var hqTime3 = 0;
                } else {
                    var hqTime3 = 6 - ((hqTime1 - hqTime0)/(60*60*1000))%6;
                }
                var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh:mm',hqTime).substr(0,13) + ':00';
                this.mylCz.sjfw = aaTime;
            } else if (val == 12) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (((hqTime1 - hqTime0)/(60*60*1000))%12 == 0) {
                    var hqTime3 = 0;
                } else {
                    var hqTime3 = 12 - ((hqTime1 - hqTime0)/(60*60*1000))%12;
                }
                var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh:mm',hqTime).substr(0,13) + ':00';
                this.mylCz.sjfw = aaTime;
            } else if (val == 24) {
                let aaTime = [];
                aaTime[0] = this.jcTime[0].substr(0,13) + ':00';
                var hqTime0 = this.xgDate(this.jcTime[0].substr(0,13) + ':00:00');
                var hqTime1 = this.xgDate(this.jcTime[1].substr(0,13) + ':00:00');
                if (((hqTime1 - hqTime0)/(60*60*1000))%24 == 0) {
                    var hqTime3 = 0;
                } else {
                    var hqTime3 = 24 - ((hqTime1 - hqTime0)/(60*60*1000))%24;
                }
                var hqTime = new Date(hqTime1 + hqTime3 * 60 * 60 * 1000);
                aaTime[1] = this.frontOneHour('yyyy-MM-dd hh',hqTime).substr(0,13) + ':00';
                this.mylCz.sjfw = aaTime;
            }
            this.jygcData();
        },

        frontOneHour (fmt,hqTime) {
            var currentTime = hqTime;
            var o = {
                'M+': currentTime.getMonth() + 1, // 月份
                'd+': currentTime.getDate(), // 日
                'h+': currentTime.getHours(), // 小时
                'm+': currentTime.getMinutes(), // 分
                's+': currentTime.getSeconds(), // 秒
                'q+': Math.floor((currentTime.getMonth() + 3) / 3), // 季度
                'S': currentTime.getMilliseconds() // 毫秒
            }
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (currentTime.getFullYear() + '').substr(4 - RegExp.$1.length))
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
            return fmt
        },

        zxtData(){
            this.loading = true;
            if (this.orForm.hour == 0) {
                let htGE = this.mylCz.sjfw[0] + ':00';
                let htLE = this.mylCz.sjfw[1] + ':00';
                let a = {
                    ...this.orForm,
                    stcd:this.mylCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get("/rm-mrain/v1/rain-pro/list",{params:a}).then((res) => {
                    if(res.ok){
                        this.ozxtData = res.data;
                        let _this = this;
                        this.ozxtDataX = [];
                        this.ozxtDataY1 = [];
                        this.ozxtDataY2 = [];
                        this.ozxtData.forEach(function(value,index,obj) {
                            _this.ozxtDataX.push(value.tm);
                            _this.ozxtDataY1.push(value.rainValue);
                            _this.ozxtDataY2.push(value.dhpSum);
                        })
                        this.$nextTick(()=>{
                            //元素加载完成后执行的代码
                            this.initssChar();
                        });
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            } else {
                let htGE = this.mylCz.sjfw[0].substr(0,13);
                let htLE = this.mylCz.sjfw[1].substr(0,13);
                let a = {
                    ...this.orForm,
                    stcd:this.mylCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get("/rm-mrain/v1/rain-pro/hour/list",{params:a}).then((res) => {
                    if(res.ok){
                        this.ozxtData = res.data;
                        let _this = this;
                        this.ozxtDataX = [];
                        this.ozxtDataY1 = [];
                        this.ozxtDataY2 = [];
                        this.ozxtData.forEach(function(value,index,obj) {
                            _this.ozxtDataX.push(value.ht);
                            _this.ozxtDataY1.push(value.rainValue);
                            _this.ozxtDataY2.push(value.dhpSum);
                        })
                        this.$nextTick(()=>{
                            //元素加载完成后执行的代码
                            this.initssChar();
                        });
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            }
            
        },
        //折线图绘制
        initssChar(){
            let _that = this;
            let ztcd;
            if (this.orForm.hour == 0) {
                ztcd = 16;
            } else if (this.orForm.hour == 1) {
                ztcd = 16;
            } else if (this.orForm.hour == 3) {
                ztcd = 16;
            } else if (this.orForm.hour == 6) {
                ztcd = 16;
            } else if (this.orForm.hour == 12) {
                ztcd = 10;
            } else if (this.orForm.hour == 24) {
                ztcd = 10;
            }
            
            let zxtCharts = this.$echarts.init(document.getElementById("chartZxt"));
            
            let option = {
                color: ['#24bd8a'],
                tooltip: {
                    //鼠标悬停提示内容
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                },
                toolbox: {
                    show: this.orForm.hour == 0 ? true : false,
                    feature:{
                        dataZoom: {
                            yAxisIndex:"none"
                        },//其他功能性按钮查看官网进行增加，包括（显示数据，下载图片，改为柱状图等）
                    },
                    right:30,
                    top:-8
                },
                legend: {
                    data: ['雨量(mm)', '累计雨量(mm)']
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,//x轴两边不留空白
                    data: this.ozxtDataX,
                    axisLabel:{  
                        formatter : function(params){
                            return _that.controlShowLength(params, ztcd);
                        }
                    },
                    axisTick: {
                        show: false  // 是否显示刻度线
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '雨量(mm)',
                    },
                    {
                        type: 'value',
                        name: '累计雨量(mm)',
                    },
                ],
                series: [
                    {
                        name: '雨量(mm)',
                        type: 'bar',
                        data: this.ozxtDataY1,
                        barWidth: 14, // 柱状图的宽度
                        itemStyle: {
                            color: '#0675e9',
                        }
                    },
                    {
                        name: '累计雨量(mm)',
                        data: this.ozxtDataY2,
                        type: 'line',
                        // smooth: true,
                        areaStyle: {
                            color: {
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0.1,
                                        color: 'rgba(151, 249, 207, 0.7) ' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.9,
                                        color: 'rgba(151, 249, 207, 0.1)' // 100% 处的颜色
                                    }
                                ]
                            }
                        }
                    }
                ]
            };
            zxtCharts.setOption(option,true);
            zxtCharts.resize();
            window.addEventListener("resize", function () {
                zxtCharts.resize();
            });
            this.loading = false;
        },
        controlShowLength(params, length){
            if (length != null) {
                if (length == 16) {
                    params = params.substring(0, 13) + ':00';
                } else {
                    params = params.substring(0, length);
                }
            }
            var newParamsName = "";
            newParamsName = params;
            return newParamsName
        },
        bgData(){
            if (this.orForm.hour == 0) {
                let htGE = this.mylCz.sjfw[0] + ':00';
                let htLE = this.mylCz.sjfw[1] + ':00';
                let a = {
                    ...this.orForm,
                    stcd:this.mylCz.cz.stcd,
                    tmGT:htGE,
                    tmLE:htLE,
                }
                this.request.get("/rm-mrain/v1/rain-pro/pageList",{params:a}).then((res) => {
                    if(res.ok){
                        this.otableData = res.data.records;
                        this.orForm.total = res.data.total;
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            } else {
                let htGE = this.mylCz.sjfw[0].substr(0,13);
                let htLE = this.mylCz.sjfw[1].substr(0,13);
                let a = {
                    ...this.orForm,
                    stcd:this.mylCz.cz.stcd,
                    htGT:htGE,
                    htLE:htLE,
                }
                this.request.get("/rm-mrain/v1/rain-pro/hour/pageList",{params:a}).then((res) => {
                    if(res.ok){
                        this.otableData = res.data.records;
                        this.orForm.total = res.data.total;
                    }else{
                        this.$message.error(res.error.message);
                        this.loading = false;
                    }
                });
            }
        },
        oreset() {
            this.orForm.hour = 0;
            // this.sjdChange(0);
            this.mylCz.sjfw = this.csTime;
            this.jygcData();
        },
        // 切换分页
        ocurrentChange(val) {
            this.orForm.current = val;
            this.bgData();
        },
        // 显示最大条数变动
        osizeChange(val) {
            this.orForm.size = val;
            this.bgData();
        },
        exportJygc(){
            let htGE = this.mylCz.sjfw[0].substr(0,13);
            let htLE = this.mylCz.sjfw[1].substr(0,13);
            let b = {
                ...this.orForm,
                stcd:this.mylCz.cz.stcd,
                htGT:htGE,
                htLE:htLE,
            }
            this.request.get('/rm-mrain/v1/rain-pro/hour/export',{ params: b,responseType: "blob" }).then((res) => {
                try {
                    let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    const a = document.createElement("a");
                    a.href = URL.createObjectURL(blob);
                    // 这里填保存成的文件名
                    a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
                    a.click();
                    URL.revokeObjectURL(a.href);
                    return;
                } catch (error) {
                    const reader = new FileReader(); 
                    reader.readAsText(res.data, 'utf-8');
                    let _this = this;
                    reader.onload=function(){
                        const msg = JSON.parse(reader.result);
                        if (!msg.ok) {
                            if (msg.error.code == 3001) {
                                _this.$message.error(msg.error.message);
                            } else {
                                _this.$message.warning(msg.error.message);
                            }
                        }
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
::v-deep .el-dialog{
    margin-top: 110px !important;
    margin-bottom:0;
    width: 100% !important; 
    height: calc(100% - 110px);
}
/*去除头部*/
::v-deep .el-dialog__header{
    display: none;
}
/*去除尾部*/
::v-deep .el-dialog__footer{
    display: none;
}
::v-deep .el-dialog__body{
    height: 100%;
    padding: 0px;
}
.zxtys{
    height: 100%;
    width: 100%;
}

/* 按钮样式 */
.queryButton {
    font-family: PingFang SC;
    font-size: 1.4rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    border-radius: 0.5rem;
    margin-left: 1.5rem;
}
.czBut {
    background-color: #a8a8a8;
    border: solid 0rem #f4f4f4;
}
.queryButtonPadding {
    padding-left: 2rem;
    padding-right: 2rem;
}
.qDcImg {
    width: 1.2rem;
    height: 1.2rem;
}
.qDcBtn {
    position: absolute;
    right: 4rem;
}
</style>
